interface IconProps {
  color?: string
}

export const CheckCircle = ({ color }: IconProps) => {
  return (
    <svg
      aria-hidden="true"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0594 10.8323C19.4085 10.5049 19.4262 9.95642 19.0989 9.60724C18.7715 9.25806 18.223 9.24037 17.8738 9.56774L11.3557 15.6787L8.39266 12.901C8.04346 12.5737 7.495 12.5914 7.16765 12.9406C6.84029 13.2898 6.85801 13.8383 7.20721 14.1656L10.763 17.499C11.0964 17.8115 11.6151 17.8115 11.9485 17.4989L19.0594 10.8323Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M13.1333 0C6.0272 0 0.266602 5.7606 0.266602 12.8667C0.266602 19.9727 6.0272 25.7333 13.1333 25.7333C20.2393 25.7333 25.9999 19.9727 25.9999 12.8667C25.9999 5.7606 20.2393 0 13.1333 0ZM1.99993 12.8667C1.99993 6.7179 6.9845 1.73333 13.1333 1.73333C19.282 1.73333 24.2666 6.7179 24.2666 12.8667C24.2666 19.0154 19.282 24 13.1333 24C6.9845 24 1.99993 19.0154 1.99993 12.8667Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  )
}
